import styled from 'styled-components';
import { Input } from '@leasequery/lq.react-component-library';
import ReportFieldDropDown from '../ReportFieldDropDown';

interface ValueInputProps {
  hasError?: boolean;
}

const ValueInput = styled(Input)<ValueInputProps>`
  input {
    ${(props): string =>
      props.hasError ? `border-color: ${props.theme.colors.basicRed}` : ''};
  }
`;

const DropdownInput = styled(ReportFieldDropDown)<ValueInputProps>`
  > button {
    ${(props): string =>
      props.hasError ? `border-color: ${props.theme.colors.basicRed}` : ''};
  }
`;

export { ValueInput, DropdownInput };
